export enum PaymentStatus {
	Approved = 'D',
	Pending = 'T',
	Rejected = 'F',
	Unreconciled = 'U',
	EXPIRED = 'X',
}
export enum PaymentStatusText {
	Approved = 'Approved',
	Pending = 'Pending',
	Rejected = 'Rejected',
	Unreconciled = 'Unreconciled',
	Expired = 'Expired',
}

export const paymentStatusList = [
	{ name: 'All', value: '', id: '1' },
	{ name: 'Approved', value: 'D', id: '2' },
	{ name: 'Pending', value: 'T', id: '3' },
	{ name: 'Rejected', value: 'F', id: '4' },
	{ name: 'Unreconciled', value: 'U', id: '5' },
	{ name: 'Expired', value: 'X', id: '6' },
];

export enum ErrorCodes {
	SERVER_5XX_ERROR = '500',
	UNKNOWN_ERROR = '501',
	SERVER_4XX_ERROR = '403',
	REQUEST_TIMEOUT = '408',
	UNAUTHORIZED = '404',
	TRANSACTION_REJECTED = '200',
	TRANSACTION_DECLINED_TECHNICAL_ERROR = '300',
	TRANSACTION_DECLINED_OTHER_REASON = '301',
	TRANSACTION_APPROVAL_DENIED = '400',
	INCORRECT_MOBILE_OR_PAYMENT_ALIAS_ID = '401',
	TRANSACTION_DENIED_WITH_DIFFERENT_ERROR = '402',
	ESB_FAILURE = '300',
	PAYMENT_SUBMISSION_FAILURE = '601',
}
